export default __webpack_public_path__ + "static/logo-bdce0308d6dac6258f5f9c30993083ac.svg";